<template>
    <div ref="info_tip" v-click-outside="{exclude: [], handler: 'close'}" class="info-tip">
        <span
            ref="icon_info"
            :class="{opened:isOpen, 'icon-info': regular}"
            class="icon icon-thin-info"
            @click="toggle" />
        <div
            v-show="isOpen"
            ref="tipcontent"
            class="content"
            :title="$t('f_close')"
            @click="close">
            <!--<span @click="close" class="icon icon-cross"></span>-->
            <div v-if="title" class="title">
                {{ title }}
            </div>
            <div class="text">
                {{ text }}
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    props: ['title', 'text', 'regular'],
    data() {
      return {
        isOpen: false
      }
    },
    created() {
      this.$root.$on("info-tip-toggle", () => {
        this.isOpen = false;
      })
    },
    methods: {
      toggle() {
        this.$root.$emit('info-tip-toggle')
        this.isOpen = !this.isOpen
        if(this.isOpen) {
          setTimeout(() => {
            if(Object.values(this.$refs.info_tip.classList).includes("bottom")) {
              if(this.$refs.info_tip.parentNode.nodeName==="H1") {
                this.$refs.tipcontent.style.bottom = '-' + (this.$refs.tipcontent.offsetHeight + 3) + 'px'
              } else {
                this.$refs.tipcontent.style.bottom = (this.$refs.icon_info.offsetHeight - this.$refs.icon_info.offsetTop) + 'px'
              }
            } else {
              this.$refs.tipcontent.style.top = '-' + (this.$refs.tipcontent.offsetHeight + 9 - this.$refs.icon_info.offsetTop) + 'px'
            }
          }, 0);
        }
      },
      close() {
        this.isOpen = false;
      }
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .info-tip {
    display: inline-block;

    &.bottom {
      > .icon {
        &.opened:after {
          content: "";
          top: 15px;
          bottom: 0px;
          right: -2px;
          width: 0;
          height: 0;
          display: block;
          position: absolute;
          border-top: none;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #8594a0;
        }
      }

      .content {
        top: 40px;
        bottom: auto;
        height: fit-content;
      }
    }

    &.right-content {
      .content {
        left: auto;
        right: 0;
      }
    }

    .icon {
      cursor: pointer;
    }

    > .icon {
      position: relative;

      &.opened:after {
        content: "";
        top: -10px;
        right: -2px;
        width: 0;
        height: 0;
        display: block;
        position: absolute;
        border-top: 10px solid #a0a8af;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
      }
    }

    .content {
      left: 0;
      z-index: 2;
      bottom: 90px;
      width: 100%;
      padding: 15px;
      color: white;
      position: absolute;
      box-sizing: border-box;
      background-color: $gray_b;
      cursor: pointer;
      user-select: none;
      box-shadow: 0px 5px 52px -10px rgba(0, 0, 0, 1);
      height: fit-content;

      html.tablet &, html.desktop & {
        width: auto;
        max-width: 450px;
      }

      .icon {
        top: 0;
        right: 0;
        padding: 15px;
        font-size: 12px;
        position: absolute;
      }

      .title {
        margin: 0 0 10px 0;
        font-size: 18px;
        text-align: left;
        position: relative;
        padding-bottom: 10px;
        padding-right: 15px;
        border-bottom: 1px solid #8a929a;
      }

      .text {
        font-size: 14px;
        font-style: italic;
      }
    }
  }
</style>

